import { renderLucideIcon } from '../utils/lucide-icons.js'

function normalizeWelcomeActions(value) {
  var source = value && Array.isArray(value.items) ? value.items : Array.isArray(value) ? value : []

  return source.map(function (item) {
    if (!item || typeof item !== 'object') return null
    var label = String(item.label || '').trim()
    var prompt = String(item.prompt || '').trim()
    var shortcut = String(item.shortcut || '').trim()
    if (!label || !prompt || !shortcut) return null

    return {
      label: label,
      prompt: prompt,
      shortcut: shortcut,
      icon: String(item.icon || 'sparkles').trim() || 'sparkles'
    }
  }).filter(Boolean)
}

function renderWelcomeActions(value) {
  var actions = normalizeWelcomeActions(value)
  if (!actions.length) return ''

  var heading = value && !Array.isArray(value) ? String(value.heading || '').trim() : ''
  var headingHtml = heading
    ? '<h2 class="wc-welcome-actions-title">' + escapeHtml(heading) + '</h2>'
    : ''

  return '<section class="wc-welcome-actions" aria-label="' + escapeHtml(heading || 'Exemples pour commencer') + '">' +
    headingHtml +
    '<div class="wc-welcome-actions-list">' +
    actions.map(function (action, index) {
      return '<button class="wc-welcome-action" type="button" data-welcome-action-index="' + index + '">' +
        '<span class="wc-welcome-action-icon">' + renderLucideIcon(action.icon) + '</span>' +
        '<span class="wc-welcome-action-label">' + escapeHtml(action.label) + '</span>' +
        '<span class="wc-welcome-action-arrow" aria-hidden="true">' + renderLucideIcon('arrowRight') + '</span>' +
        '</button>'
    }).join('') +
    '</div>' +
    '</section>'
}

function bindWelcomeActions(root, value, handlers) {
  if (!root) return
  var actions = normalizeWelcomeActions(value)
  var onSelect = handlers && typeof handlers.onSelect === 'function' ? handlers.onSelect : null
  if (!onSelect) return

  Array.prototype.slice.call(root.querySelectorAll('[data-welcome-action-index]')).forEach(function (button) {
    button.addEventListener('click', function () {
      var index = Number(button.getAttribute('data-welcome-action-index'))
      var action = actions[index]
      if (action) onSelect(action, button)
    })
  })
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { bindWelcomeActions, normalizeWelcomeActions, renderWelcomeActions }
